/* global FormData */
import ErrorMessage from "components/ErrorMessage";
import OButton from "components/reusable/OButton";
import useToastContext from "hooks/useToastContext";
import React, { useEffect, useContext, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { apiGet, apiPost } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { AiFillCamera } from "react-icons/ai";
import PhoneInput from "react-phone-input-2";
import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import OImage from "components/reusable/OImage";
import OInputField from "components/reusable/OInputField";
import formValidation from "utils/formValidation";
import OSelect from "components/reusable/OSelect";
import OMultiSelect from "components/reusable/OMultiSelect";
import AuthContext from "context/AuthContext";
import "react-phone-input-2/lib/style.css";
import helper from "utils/helpers";
import helpers from "utils/helpers";

const AddAgent = ({ setShowModal, allAgent, totalAgents }) => {
  const { t } = useTranslation();
  const inputRef = useRef(null);
  const { defaultCountry } = useContext(AuthContext);

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
  });
  const notification = useToastContext();
  const [language, setLanguage] = useState([]);
  const [roles, setRoles] = useState([]);
  const [nationalityArray, setNationalityArray] = useState([]);
  const [languageArray, setLanguageArray] = useState([]);
  const [isLanguageError, setIsLanguageError] = useState(false);
  const [communityError, setIsCommunityError] = useState(false);
  const [profilePic, setProfilePic] = useState(null);
  const [profilePicError, setProfilePicError] = useState("");
  const [communityArray, setCommunityArray] = useState([]);
  const [community, setCommunity] = useState([]);
  const department = [
    { key: "all", value: "All" },
    { key: "residential", value: "Residential" },
    { key: "commercial", value: "Commercial" },
  ];
  const profilePicRef = useRef();
  const validateFiles = (profilePicNew) => {
    let picError = "";
    const supportedTypes = ["image/jpeg", "image/jpg", "image/png"];

    if (!isEmpty(supportedTypes.includes(profilePicNew.type))) {
      picError = "Only jpeg, jpg and png are supported.";
    }
    if (picError) {
      setProfilePicError(picError);
      return false;
    } else {
      setProfilePicError("");
      return true;
    }
  };

  const handleFileChange = (e) => {
    const image = e?.target?.files[0];
    const isValidImage = validateFiles(image);
    if (isValidImage) {
      setProfilePic(image);
    } else {
      setProfilePic(null);
    }
  };
  const checkLanguage = () => {
    const isValid = language?.length !== 0;
    setIsLanguageError(!isValid);
    return isValid;
  };
  const checkSpecilized = () => {
    const isValid = community?.length !== 0;
    setIsCommunityError(!isValid);
    return isValid;
  };

  const onSubmit = async (data) => {
    try {
      if (data.order && data.order < 1) {
        notification.error(`${t("PLEASE_ENTER_VALID_AGENT_ORDER")}`);
        return;
      }
      // setUpdatePrfileLoading(true)
      const isValid = checkLanguage();
      const isSpecialized = checkSpecilized();
      if (!isValid || !isSpecialized) return;
      const languages = language?.map((item) => item.value).join(",");
      data.mobile = data?.mobile?.substring(
        inputRef?.current?.state.selectedCountry?.countryCode?.length,
        data?.mobile?.toString()?.length,
      );
      data.countryCode = inputRef?.current?.state.selectedCountry?.countryCode;
      const formData = new FormData();
      formData.append("firstName", data.firstName);
      formData.append("firstNameAr", data.firstNameAr);
      formData.append("lastName", data.lastName);
      formData.append("lastNameAr", data.lastNameAr);
      formData.append("email", data.email);
      formData.append("mobile", data.mobile);
      formData.append("brn", data.brn);
      formData.append("countryCode", data.countryCode);
      formData.append("nationality", data.nationality);
      formData.append("language", languages);
      formData.append("designation", data.designation);
      formData.append("designationAr", data.designationAr);
      formData.append("order", data.order);
      formData.append("profilePic", profilePic);
      formData.append("role", data.role);
      formData.append("department", data.department);
      for (let i = 0; community.length > i; i++) {
        formData.append("communityId", community[i]?.value);
      }

      const { data: response } = await apiPost(apiPath.addAgent, formData);
      if (response.success) {
        notification.success(response.message);
        allAgent();
        setShowModal(false);
        reset();
      } else {
        notification.error(response.message);
      }
    } catch (err) {
      console.error("err:", err);
    }
  };
  useEffect(() => {
    getMasterData();
    // getCommunities()
  }, []);

  const getMasterData = async () => {
    const response = await apiGet(apiPath.getUserMasterData);
    const tempNationality = response?.data?.results?.country?.map((item) => {
      return { key: item?.name, value: item?.name };
    });
    setNationalityArray(tempNationality);
    const tempLanguage = response?.data?.results?.language?.map((item) => {
      return { label: item?.name, value: item?.name };
    });
    setLanguageArray(tempLanguage);

    const { data } = await apiGet(
      helpers.isSaudi()
        ? `${apiPath.allCommunities}?type=saudi`
        : apiPath.allCommunities,
    );
    const tempCommunity = data?.results?.map((newItem) => {
      return { label: newItem?.name, value: newItem?._id };
    });
    setCommunityArray(tempCommunity);
    const { data: rolesResponse } = await apiGet(apiPath.agentRoles);
    setRoles(rolesResponse?.results);
  };

  return (
    <div>
      <>
        <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
          <div className="relative my-6  w-full max-w-[1150px] mx-auto">
            <div className="sm:py-4 sm:px-2 py-8 px-7 ">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-xl font-semibold">
                    {t("ADD_AGENT_FORM")}
                  </h3>
                  <button
                    className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
                    <span className=" text-[#B8BBBF]  text-4xl " title="Close">
                      ×
                    </span>
                  </button>
                </div>
                <div className="relative p-6 flex-auto">
                  <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                    <div className="px-2">
                      <OInputField
                        wrapperClassName="relative z-0 mb-6  w-full group"
                        name="firstName"
                        inputLabel={
                          <>
                            {t("O_FIRST_NAME")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="text"
                        autoFocus
                        maxLength={15}
                        register={register(
                          "firstName",
                          formValidation.agentFirstName,
                        )}
                        errors={errors}
                      />
                    </div>
                    <div className="px-2">
                      <OInputField
                        wrapperClassName="relative z-0 mb-6  w-full group"
                        name="firstNameAr"
                        inputLabel={
                          <>
                            {t("O_FIRST_NAME") + t("O_ARABIC")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="text"
                        maxLength={15}
                        register={register(
                          "firstNameAr",
                          formValidation.agentFirstNameAr,
                        )}
                        errors={errors}
                      />
                    </div>

                    <div className="px-2">
                      <OInputField
                        wrapperClassName="relative z-0 mb-6  w-full group"
                        name="lastName"
                        inputLabel={
                          <>
                            {t("O_LAST_NAME")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="text"
                        maxLength={15}
                        register={register(
                          "lastName",
                          formValidation.agentLastName,
                        )}
                        errors={errors}
                      />
                    </div>
                    <div className="px-2">
                      <OInputField
                        wrapperClassName="relative z-0 mb-6  w-full group"
                        name="lastNameAr"
                        inputLabel={
                          <>
                            {t("O_LAST_NAME") + t("O_ARABIC")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="text"
                        maxLength={15}
                        register={register(
                          "lastNameAr",
                          formValidation.agentLastNameAr,
                        )}
                        errors={errors}
                      />
                    </div>
                    <div className="px-2">
                      <OInputField
                        wrapperClassName="relative z-0   w-full group"
                        name="email"
                        inputLabel={
                          <>
                            {t("O_EMAIL_ID")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="email"
                        register={register("email", formValidation.email)}
                        errors={errors}
                      />
                    </div>
                    <div className="px-2">
                      <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t("O_MOBILE_NUMBER")}
                      </p>
                      <Controller
                        control={control}
                        name="mobile"
                        rules={{
                          required: t("PLEASE_ENTER_MOBILE_NUMBER"),
                          validate: (value) => {
                            const inputValue = value
                              ?.toString()
                              ?.slice(
                                inputRef?.current?.state?.selectedCountry
                                  ?.countryCode?.length,
                                value?.length,
                              );
                            if (inputValue?.length < 8) {
                              return t(
                                "MOBILE_NUMBER_MUST_CONTAIN_AT_LEAST_8_DIGITS",
                              );
                            } else if (inputValue?.length > 12) {
                              return t(
                                "MOBILE_NUMBER_SHOULD_NOT_EXCEED_12_DIGITS",
                              );
                            } else {
                              return true;
                            }
                          },
                        }}
                        render={({ field: { ref, ...field } }) => (
                          <PhoneInput
                            {...field}
                            inputExtraProps={{
                              ref,
                              required: true,
                              autoFocus: true,
                            }}
                            ref={inputRef}
                            inputStyle={{
                              width: "100%",
                              height: "42px",
                            }}
                            style={{ borderRadius: "20px" }}
                            country={defaultCountry}
                            enableSearch
                            countryCodeEditable={false}
                          />
                        )}
                      />
                      <ErrorMessage message={errors?.mobile?.message} />
                    </div>
                    <div className="px-2">
                      <OInputField
                        wrapperClassName="relative z-0   w-full group"
                        name="brn"
                        inputLabel={
                          <>
                            {t("O_BRN_NUMBER")}
                            {/* <span className='text-red-500'>*</span> */}
                          </>
                        }
                        onKeyPress={(e) => {
                          helper.isVarCharNumber(e);
                          helper.maxInputNumber(12, e);
                        }}
                        type="text"
                        register={register("brn")}
                      />
                    </div>

                    <div className="px-2">
                      <OInputField
                        wrapperClassName="relative z-0   w-full group"
                        name="designation"
                        inputLabel={
                          <>
                            {t("O_DESIGNATION")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="text"
                        register={register(
                          "designation",
                          formValidation.designation,
                        )}
                        errors={errors}
                      />
                    </div>
                    <div className="px-2">
                      <OInputField
                        wrapperClassName="relative z-0   w-full group"
                        name="designationAr"
                        inputLabel={
                          <>
                            {t("O_DESIGNATION") + t("O_ARABIC")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="text"
                        register={register(
                          "designationAr",
                          formValidation.designationAr,
                        )}
                        errors={errors}
                      />
                    </div>
                    <div className="px-2">
                      <OSelect
                        wrapperClassName="relative z-0 mb-6 w-full group"
                        name="nationality"
                        inputLabel={
                          <>
                            {t("O_SELECT_NATIONALITY")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="select"
                        options={nationalityArray}
                        defaultValue={t("O_SELECT_NATIONALITY")}
                        register={register(
                          "nationality",
                          formValidation.nationality,
                        )}
                        errors={errors}
                      />
                    </div>

                    <div className="px-2">
                      <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t("O_SELECT_LANGUAGE")}
                      </p>
                      <OMultiSelect
                        wrapperClassName="relative z-0 mb-6 w-full group"
                        name="language"
                        placeholder={
                          <>
                            {t("O_SELECT_LANGUAGE")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        options={languageArray}
                        defaultValue={t("O_SELECT_LANGUAGE")}
                        onChange={setLanguage}
                        value={language}
                      />
                      {isLanguageError && (
                        <ErrorMessage message="Please select language." />
                      )}
                    </div>
                    <div className="px-2">
                      {/* <OSelect
                        wrapperClassName='relative z-0 mb-6 w-full group'
                        name='order'
                        inputLabel={
                          <>
                            {t('AGENT_ORDER')}
                          </>
                        }
                        type='select'
                        options={agentOrder}
                        defaultValue={t('SELECT_AGENT_ORDER')}
                        register={register('order')}
                        errors={errors}
                      /> */}
                      <OInputField
                        wrapperClassName="relative z-0 mb-6  w-full group"
                        name="order"
                        id="order"
                        inputLabel={<>{t("AGENT_ORDER")}</>}
                        type="number"
                        register={register("order")}
                        errors={errors}
                      />
                    </div>
                    <div className="px-2">
                      <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t("SPECIALIZED_AREA")}
                      </p>
                      <OMultiSelect
                        wrapperClassName="relative z-0 mb-6 w-full group"
                        name="specializedArea"
                        placeholder={
                          <>
                            {t("SPECIALIZED_AREA")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        options={communityArray}
                        defaultValue={t("SPECIALIZED_AREA")}
                        onChange={setCommunity}
                        value={community}
                      />
                      {communityError && (
                        <ErrorMessage message="Please select Specialized area." />
                      )}
                      {/* <OSelect
                        wrapperClassName='relative z-0 mb-6 w-full group'
                        name='specializedArea'
                        id='specializedArea'
                        inputLabel={
                          <>
                            {t('SPECIALIZED_AREA')}
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        type='select'
                        options={communityArray}
                        defaultValue={t('SPECIALIZED_AREA')}
                        register={register('specializedArea',formValidation.specializedArea)}
                        errors={errors}
                      /> */}
                    </div>
                    <div className="px-2">
                      <OSelect
                        wrapperClassName="relative z-0 mb-6 w-full group"
                        name="role"
                        inputLabel={
                          <>
                            {t("O_SELECT_ROLE")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="select"
                        options={roles.map((item) => ({
                          key: item.label,
                          value: item.label,
                        }))}
                        defaultValue={t("O_SELECT_ROLE")}
                        register={register("role", {
                          required: t("PLEASE_SELECT_ROLE"),
                        })}
                        errors={errors}
                      />
                    </div>
                    <div className="px-2">
                      <OSelect
                        wrapperClassName="relative z-0 mb-6 w-full group"
                        name="department"
                        inputLabel={
                          <>
                            {t("O_DEPARTMENT")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="select"
                        options={department.map((item) => ({
                          key: item.value,
                          value: item.value,
                        }))}
                        defaultValue={t("O_DEPARTMENT")}
                        register={register("department", {
                          required: t("PLEASE_SELECT_DEPARTMENT"),
                        })}
                        errors={errors}
                      />
                    </div>
                  </div>
                  <div className="py-4 flex justify-start ml-2">
                    {/* <div className='relative'> */}
                    <div>
                      <label className="block mb-2 text-sm cursor-pointer font-medium text-gray-900 dark:text-white w-30">
                        {!profilePic ? (
                          <span
                            // className='flex align-center'
                            className="bg-[#8FC150] hover:bg-[#8FC150] cursor-pointer   text-white  font-normal active:bg-slate-100 text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150
                                  undefined "
                            onClick={() => profilePicRef?.current?.click()}
                          >
                            {t("UPLOAD_PROFILE_PICTURE")}
                          </span>
                        ) : (
                          <span className="flex align-center">
                            {t("UPLOAD_PROFILE_PICTURE")}
                          </span>
                        )}
                      </label>
                      <input
                        type="file"
                        accept="image/png, image/jpg, image/jpeg"
                        name="profilePic"
                        ref={profilePicRef}
                        onChange={handleFileChange}
                        className="hidden"
                      />

                      <div className="relative">
                        {profilePic && (
                          <OImage
                            src={
                              profilePic ? URL.createObjectURL(profilePic) : ""
                            }
                            fallbackUrl="/images/user.png"
                            className="w-24 h-24 m-auto"
                            alt=""
                            style={{ borderRadius: "50%" }}
                          />
                        )}

                        {profilePic && (
                          <AiFillCamera
                            className=" bg-gray-100  absolute w-4 rounded-xl cursor-pointer "
                            style={{
                              width: "1.5rem",
                              height: "1.5rem",
                              bottom: "0",
                              right: "20px",
                              background: "",
                              padding: "1px",
                            }}
                            onClick={() => profilePicRef?.current?.click()}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="text-center mt-4">
                    <ErrorMessage message={profilePicError} />
                  </div>
                </div>
                <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
                  <button
                    className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    {t("O_BACK")}
                  </button>
                  <OButton
                    label={<>{t("O_ADD")}</>}
                    type="submit"
                    onClick={handleSubmit(onSubmit, () => {
                      checkLanguage();
                      checkSpecilized();
                    })}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="opacity-25 fixed inset-0 z-40 bg-black" />
      </>
    </div>
  );
};

export default AddAgent;
